import dayjs from 'dayjs';
import { Duration } from 'dayjs/plugin/duration.js';
import { TimeZone } from '../../time/timezone.js';
import { DataModelBuilder, SerializationContext, SerializedData } from '../../models/dto/dto.js';
import { MapUtils } from '../../utility/map-utils.js';
import { Component } from '../core/component.js';

export class PoolServiceDurationComponent extends Component {
  static readonly TYPE_ID: string = 'ff372e592fbf451fbc0d278a5b924364';

  public readonly duration: Duration;

  constructor(
      duration: Duration | null = null,
  ) {
    super();

    this.duration = duration ?? dayjs.duration(0);
  }

  get $removable(): boolean {
    return false;
  }

  get $typeId(): string {
    return PoolServiceDurationComponent.TYPE_ID;
  }

  static fromMap(context: SerializationContext, map: SerializedData): PoolServiceDurationComponent {
    return new PoolServiceDurationComponent(
        context.decodeDurationOrNull(MapUtils.getOrNull<number>(map, 'duration')),
    );
  }

  toMap(context: SerializationContext): SerializedData {
    return {
      'duration': context.encodeDurationOrNull(this.duration),
    };
  }

  clone(): this {
    return new PoolServiceDurationComponent(
        TimeZone.cloneDuration(this.duration),
    ) as this;
  }

  isSame(other: this): boolean {
    if(other === this) {
      return true;
    }

    return other.duration === this.duration;
  }
}

export class PoolServiceDurationComponentBuilder extends DataModelBuilder<PoolServiceDurationComponent> {
  build(context: SerializationContext, map: SerializedData): PoolServiceDurationComponent {
    return PoolServiceDurationComponent.fromMap(context, map);
  }
}
